import React, { useCallback, useEffect, useState } from "react"
import { gql, useQuery } from "@apollo/client"

import useInfiniteScroll from "hooks/useInfiniteScroll"
import { useCombobox, useMultipleSelection } from "downshift"
import { useDropzone } from "react-dropzone"
import Modal from "../../../../UI/Modal"
// import Modal from "../../../Modal"
import Img from "../../../Img"

import { upload } from "lib/firebase"
import readFile from "utils/readFile"

const InputImage = (props) => {
  const { library } = props

  return (
    <>
      {library ? (
        <LibrarySelection {...props} />
      ) : (
        <DropzoneSelection {...props} />
      )}
    </>
  )
}

export default InputImage

const DropzoneSelection = ({
  value,
  multiple,
  library,
  variant,
  preload,
  onChange,
}) => {
  const [isUploading, setIsUploading] = useState(false)
  const [files, setFiles] = useState(null)

  useEffect(() => {
    if (files && files?.length > 0) {
      onChange(multiple ? files?.map((_) => _.metadata) : files[0]?.metadata)
    }
  }, [files])

  const onDrop = async (acceptedFiles) => {
    try {
      const filesForUpload = await Promise.all([...acceptedFiles.map(readFile)])

      if (filesForUpload?.length === 0) return

      setFiles((prevState) => [
        ...(prevState ? prevState : []),
        ...filesForUpload,
      ])
      setIsUploading(true)

      const uploadedFiles = await Promise.all([
        ...filesForUpload.map((file, index) =>
          upload(file, (progress) =>
            setFiles((prevState) =>
              prevState.map((x) => ({
                ...x,
                progress: x.id === file.id ? progress : x.progress,
              })),
            ),
          ),
        ),
      ])

      setFiles((prevState) => [
        ...(prevState
          ? prevState.map((item) => {
              const existing = uploadedFiles.find(
                (_) => _.name === item.metadata.name,
              )
              return {
                ...item,
                metadata: {
                  ...item.metadata,
                  ...(existing ? existing : {}),
                },
              }
            })
          : []),
      ])

      setIsUploading(false)
    } catch (error) {
      console.error(error)
    }
  }

  const { getRootProps, getInputProps } = useDropzone({ onDrop, multiple })

  // {/* ${variant === "round" && "aspect-w-1 aspect-h-1 rounded-full"} */}

  return (
    <div {...getRootProps({ onClick: (e) => e.stopPropagation() })}>
      <input {...getInputProps()} />

      <div className="aspect-w-1 aspect-h-1 rounded-full overflow-hidden mt-2">
        {value ? (
          <div className="w-full h-full flex flex-col justify-center items-center cursor-pointer bg-gray-100 hover:bg-gray-200">
            {multiple ? (
              <div />
            ) : (
              <div className="relative w-full h-full">
                {isUploading ? (
                  <div className="absolute inset-0 z-40 bg-black text-white text-xs flex justify-center items-center">
                    ...Uploading...
                  </div>
                ) : (
                  <img
                    className="w-full h-full object-cover"
                    src={value.url ? value.url : value}
                    alt=""
                    alt=""
                  />
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="w-full h-full flex flex-col justify-center items-center cursor-pointer bg-gray-100 hover:bg-gray-200">
            <svg
              width="48"
              height="48"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                fill="#4A5568"
              />
            </svg>

            <div className="text-gray-600 text-xs text-center  mt-2">
              <p>Drag and drop your file</p>
              <p>or click to browse</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const LibrarySelection = ({ value, multiple, preload, onChange }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  return (
    <div className="mt-2 rounded-lg overflow-hidden bg-blue-500 ">
      {value ? (
        <div
          className="w-full h-full relative cursor-pointer"
          onClick={(e) => {
            e.stopPropagation()

            setModalOpen(true)
          }}
        >
          <div className="aspect-w-16 aspect-h-9">
            <img
              className="w-full h-full object-cover"
              src={value.url ? value.url : value}
              alt=""
              alt=""
            />
          </div>
        </div>
      ) : (
        <div className="aspect-w-16 aspect-h-9 ">
          <div
            className="w-full h-full flex flex-col justify-center items-center cursor-pointer bg-gray-100 hover:bg-gray-200"
            onClick={() => setModalOpen(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-32 w-32 text-gray-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>

            <p className="text-gray-600 mt-2">Click to select</p>
          </div>
        </div>
      )}

      <MediaModal
        isOpen={isModalOpen}
        multiple={multiple}
        preload={preload}
        onClose={() => setModalOpen(false)}
        onSubmit={onChange}
      />
    </div>
  )
}

const MediaModal = ({ multiple, isOpen, onClose, onSubmit }) => {
  const FILES = gql`
    query Files(
      $filter: FileFilterInput
      $page: Int
      $size: Int
      $sort: FileSortInput
    ) {
      files(filter: $filter, page: $page, size: $size, sort: $sort) {
        id
        url
        name
        tags
      }
    }
  `

  const size = 20
  const { data, loading, fetchMore } = useQuery(FILES, {
    variables: {
      page: 0,
      size,
      sort: { timestamp: "DESC" },
    },
  })

  const { data: tagsRaw } = useQuery(gql`
    query Tags {
      tags
    }
  `)

  const tags = tagsRaw?.tags

  const hasMore = loading ? false : data?.files?.length >= size
  const [page, loaderRef] = useInfiniteScroll({ hasMore })

  const [selectedImages, setSelectedImages] = useState([])

  const handleSearch = useCallback(
    (tags) => {
      if (!fetchMore) return
      if (!tags && tags?.length > 0) return

      fetchMore({
        variables: { filter: { tags } },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return previousResult
          return Object.assign({}, previousResult, {
            files: [...fetchMoreResult?.files],
          })
        },
      })
    },
    [fetchMore],
  )

  const handleLoadMore = useCallback(
    (page) => {
      if (page === 0) return
      fetchMore({
        variables: { page },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return previousResult
          return Object.assign({}, previousResult, {
            files: [...previousResult?.files, ...fetchMoreResult?.files],
          })
        },
      })
    },
    [fetchMore],
  )

  const handleSelect = (image) => {
    // const { multiple } = props
    const selection = selectedImages.map((_) => _.id).includes(image.id)
      ? selectedImages.filter((v) => v.id !== image.id)
      : multiple
      ? [...selectedImages, image]
      : [image]

    setSelectedImages(selection)
  }

  const handleSubmit = () => {
    onSubmit && onSubmit(multiple ? selectedImages : selectedImages[0])
    setSelectedImages([])
    onClose && onClose()
  }

  // useEffect(() => {
  //   if (page === 1) return
  //   handleLoadMore(page)
  // }, [page, handleLoadMore])

  const isSelected = (id) => selectedImages?.map((_) => _.id)?.includes(id)

  // useEffect(() => {
  // }, [isOpen])

  // useEffect(() => {
  //   const unsubscribe = subscribeToMore({
  //     document: NOTIFICATION_CREATED_OR_DELETED,
  //     updateQuery: async (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) return prev;

  //       const oldNotifications = prev.getAuthUser.newNotifications;
  //       const { operation, notification } = subscriptionData.data.notificationCreatedOrDeleted;

  //       let newNotifications;

  //       if (operation === 'CREATE') {
  //         // Don't show message notification in Header if user already is on notifications page
  //         if (window.location.href.split('/')[3] === 'notifications') {
  //           return prev;
  //         }

  //         // Add new notification
  //         newNotifications = [notification, ...oldNotifications];
  //       } else {
  //         // Remove from notifications
  //         const notifications = oldNotifications;
  //         const index = notifications.findIndex((n) => n.id === notification.id);
  //         if (index > -1) {
  //           notifications.splice(index, 1);
  //         }

  //         newNotifications = notifications;
  //       }

  //       // Attach new notifications to authUser
  //       const authUser = prev.getAuthUser;
  //       authUser.newNotifications = newNotifications;

  //       return { getAuthUser: authUser };
  //     },
  //   });

  //   return () => {
  //     unsubscribe();
  //   };
  // }, [subscribeToMore]);

  return (
    <Modal title="Media" isOpen={isOpen} onClose={onClose}>
      {tags && tags?.length && (
        <InputTypeahead options={tags} onChange={handleSearch} />
      )}

      <div className="h-80 overflow-scroll">
        <ul className="grid grid-cols-4 gap-4 overflow-scroll">
          {data?.files?.map((image, index) => (
            <li
              key={index}
              className={`cursor-pointer relative rounded-lg  overflow-hidden border-2 border-transparent hover:border-indigo-300`}
              onClick={() => handleSelect(image)}
            >
              {isSelected(image.id) && (
                <div className="bg-gray-900 bg-opacity-50  absolute inset-0 z-50 flex justify-center items-center">
                  <p className="text-sm font-bold uppercase tracking-widest text-gray-100">
                    Selected
                  </p>
                </div>
              )}

              <Img aspectRatio="16/9" src={image.url} alt="" />
            </li>
          ))}

          {hasMore && (
            <div ref={loaderRef} className="text-center bg-gray-100">
              Loading…
            </div>
          )}
        </ul>
      </div>

      <div className="">
        <div className=" px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button
              onClick={handleSubmit}
              type="button"
              className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              Submit
            </button>
          </span>

          <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button
              onClick={onClose}
              type="button"
              className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              Cancel
            </button>
          </span>
        </div>
      </div>
    </Modal>
  )
}

const selectedItemIconStyles = { cursor: "pointer" }

function InputTypeahead({ options, onChange }) {
  const [inputValue, setInputValue] = useState("")
  const {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    selectedItems,
  } = useMultipleSelection({
    // initialSelectedItems: [options[0], options[1]]
  })

  useEffect(() => {
    onChange && onChange(selectedItems)
  }, [selectedItems, onChange])

  const getFilteredItems = () =>
    options?.filter(
      (item) =>
        selectedItems.indexOf(item) < 0 &&
        item.toLowerCase().startsWith(inputValue.toLowerCase()),
    )

  const {
    getComboboxProps,
    getInputProps,
    getItemProps,
    // getLabelProps,
    getMenuProps,
    // getToggleButtonProps,
    highlightedIndex,
    isOpen,
  } = useCombobox({
    inputValue,
    defaultHighlightedIndex: 0, // after selection, highlight the first item.
    selectedItem: null,
    items: getFilteredItems(),
    stateReducer: (state, actionAndChanges) => {
      const { changes, type } = actionAndChanges
      switch (type) {
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          return {
            ...changes,
            isOpen: false, // keep the menu open after selection.
          }

        default:
          return changes
      }
    },

    onStateChange: ({ inputValue, type, selectedItem }) => {
      switch (type) {
        case useCombobox.stateChangeTypes.InputChange:
          setInputValue(inputValue)
          break
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
        case useCombobox.stateChangeTypes.InputBlur:
          if (selectedItem) {
            setInputValue("")
            addSelectedItem(selectedItem)
          }
          break
        default:
          break
      }
    },
  })

  // const classNames = `mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 ${
  return (
    <div className="relative mb-4">
      {/* <label {...getLabelProps()}>Choose some elements:</label> */}
      <div className="relative z-50 group">
        <div
          className="w-full h-auto form-input flex flex-wrap items-center b border border-transparent bg-white border-gray-300 text-gray-900 rounded-lg pr-4 focus-within:border-indigo-300 focus-within:ring focus-within:ring-indigo-200 focus-within:ring-opacity-50"
          {...getComboboxProps()}
        >
          <ul className="flex space-x-1">
            {selectedItems.map((selectedItem, index) => (
              <span
                className="text-sm inline-block px-2 bg-blue-200 text-blue-800 rounded-lg"
                key={`selected-item-${index}`}
                {...getSelectedItemProps({ selectedItem, index })}
              >
                {selectedItem}

                <span
                  className="ml-2 text-xs"
                  style={selectedItemIconStyles}
                  onClick={(e) => {
                    e.stopPropagation()
                    removeSelectedItem(selectedItem)
                  }}
                >
                  &#10005;
                </span>
              </span>
            ))}
          </ul>

          <input
            {...getInputProps(getDropdownProps({ preventKeyAction: isOpen }))}
            style={{ outline: "none", marginLeft: "8px" }}
            placeholder="Search by keywords"
            className="flex-1"
          />
        </div>
      </div>

      <ul
        {...getMenuProps()}
        className={`h-48 overflow-scroll shadow-lg rounded-lg absolute left-0 right-0 opacity-0 ${
          isOpen && "opacity-100 z-40"
        }`}
      >
        {isOpen &&
          getFilteredItems(options).map((item, index) => (
            <li
              className="p-4 text-sm bg-white "
              style={
                highlightedIndex === index ? { backgroundColor: "#bde4ff" } : {}
              }
              key={`${item}${index}`}
              {...getItemProps({ item, index })}
            >
              {item}
            </li>
          ))}
      </ul>
    </div>
  )
}
